
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Data source',
	'dataSourceId': 'Id',
	'dataSourceType': 'Type',
	'dataSourceName': 'Name',
	'dataSourcePath': 'Path',
	'showInfoForAll': 'Show duration for all visualizations',
	'hideInfoForAll': 'Hide duration for all visualizations',
	'showPerformanceDetails': 'Rerun all widgets to include performance details',
	'slotMappingField': 'Slot mappings',
	'slotDataMapping': 'Mapping',
	'slotID': 'ID',
	'slotCaption': 'Caption',
	'slotMandatory': 'Mandatory',
	'slotIsMandatory': 'Yes',
	'slotIsNotMandatory': 'No',
	'infoNotAvailable': 'Unavailable',
	'performanceSection': 'Performance',
	'durationField': 'Duration',
	'singleQueryTime': 'Server query (ms)',
	'multipleQueryTime': 'Server query %{name} (ms)',
	'liveWidgetTotalTime': 'Total (ms)',
	'renderTimeNotAvailable': 'Not available',
	'renderInProgress': '(in progress)',
	'interactToTriggerQuery': 'Interact with widget to trigger a query',
	'fetchQuery': 'Fetch Query',
	'showSQLMDX': 'Show SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Query Information',
	'queryInfoNotAvailable': 'Query information not available',
	'query': 'Query',
	'copy': 'Copy',
	'close': 'Close'
});
